import React from 'react';

import { Skeleton } from '@material-ui/lab';
import Stepper from '@material-ui/core/Stepper';
import StepConnector from '@material-ui/core/StepConnector';
import { withStyles } from '@material-ui/core';

import { Colors } from '../../../../theme';

import BaseSkeleton from '../BaseSkeleton';

import { HorizontalStepperSkeletonProps } from './HorizontalStepperSkeleton.types';

const HorizontalStepperSkeleton: React.FC<HorizontalStepperSkeletonProps> = ({ className, steps }) => {

  const getStep = () => {
    return (
      <div className='flex flex-row flex-center'>
         <Skeleton variant="circle" height={20} width={20} className='mr1' />
         <BaseSkeleton  width={200} height={20} className='mr3 ml1' />
      </div>
    )
  }

  const HorizontalStepperConnector = withStyles({
    line: {
      minWidth: '20px',
      borderColor: Colors.disabled,
      borderTopWidth: '1.5px'
    }
  })(StepConnector);

  return (
    <Stepper
      className={`stepper-container ${className}`}
      activeStep={0}
      orientation="horizontal"
      connector={<HorizontalStepperConnector />} 
    >
      {steps.map(() => getStep() )}
    </Stepper>
  );
};

export default HorizontalStepperSkeleton;
export { HorizontalStepperSkeletonProps };
